<template>
  <div>
    <section class="showroomSlide">
      <h1>Quality Jobs By NG Construction</h1>
      <img id="change-image" src="../../../public/img/icons/dado1/showroomOne.jpg" alt="Black Image" />
      <modal name="img1" :adaptive="true"
        width="80%"
        height="auto"
        :max-width="1000"
        :max-height="300"
        :pivot-y="0.5"
        :scrollable="true"
        :reset="true"
         >

        <img id="image" width="100%"
          src="../../../public/img/icons/dado1/1.jpg"
          alt
        />
      </modal>
      <modal name="img2" :adaptive="true"
        width="80%"
        height="auto"
        :max-width="1000"
        :max-height="300"
        :pivot-y="0.5"
        :scrollable="true"
        :reset="true"
         >

        <img id="image" width="100%"
          src="../../../public/img/icons/dado1/2.jpg"
          alt
        />
      </modal>
      <modal name="img3" :adaptive="true"
        width="80%"
        height="auto"
        :max-width="1000"
        :max-height="300"
        :pivot-y="0.5"
        :scrollable="true"
        :reset="true"
         >

        <img id="image" width="100%"
          src="../../../public/img/icons/dado1/3.jpg"
          alt
        />
      </modal>
      <modal name="img4" :adaptive="true"
        width="80%"
        height="auto"
        :max-width="1000"
        :max-height="300"
        :pivot-y="0.5"
        :scrollable="true"
        :reset="true"
         >

        <img id="image" width="100%"
          src="../../../public/img/icons/dado1/4.jpg"
          alt
        />
      </modal>
      <modal name="img5" :adaptive="true"
        width="80%"
        height="auto"
        :max-width="1000"
        :max-height="300"
        :pivot-y="0.5"
        :scrollable="true"
        :reset="true"
         >

        <img id="image" width="100%"
          src="../../../public/img/icons/dado1/5.jpg"
          alt
        />
      </modal>
      <modal name="img6" :adaptive="true"
        width="80%"
        height="auto"
        :max-width="1000"
        :max-height="300"
        :pivot-y="0.5"
        :scrollable="true"
        :reset="true"
         >

        <img id="image" width="100%"
          src="../../../public/img/icons/dado1/6.jpg"
          alt
        />
      </modal>
      <modal name="img7" :adaptive="true"
        width="80%"
        height="auto"
        :max-width="1000"
        :max-height="300"
        :pivot-y="0.5"
        :scrollable="true"
        :reset="true"
         >

        <img id="image" width="100%"
          src="../../../public/img/icons/dado1/7.jpg"
          alt
        />
      </modal>
      <modal name="img8" :adaptive="true"
        width="80%"
        height="auto"
        :max-width="1000"
        :max-height="300"
        :pivot-y="0.5"
        :scrollable="true"
        :reset="true"
         >

        <img id="image" width="100%"
          src="../../../public/img/icons/dado1/8.jpg"
          alt
        />
      </modal>
      <modal name="img9" :adaptive="true"
        width="80%"
        height="auto"
        :max-width="1000"
        :max-height="300"
        :pivot-y="0.5"
        :scrollable="true"
        :reset="true"
         >

        <img id="image" width="100%"
          src="../../../public/img/icons/dado1/9.jpg"
          alt
        />
      </modal>
      <modal name="img10" :adaptive="true"
        width="80%"
        height="auto"
        :max-width="1000"
        :max-height="300"
        :pivot-y="0.5"
        :scrollable="true"
        :reset="true"
         >

        <img id="image" width="100%"
          src="../../../public/img/icons/dado1/10.jpg"
          alt
        />
      </modal>
      <modal name="img11" :adaptive="true"
        width="80%"
        height="auto"
        :max-width="1000"
        :max-height="300"
        :pivot-y="0.5"
        :scrollable="true"
        :reset="true"
         >

        <img id="image" width="100%"
          src="../../../public/img/icons/dado1/11.jpg"
          alt
        />
      </modal>
      <modal name="img12" :adaptive="true"
        width="80%"
        height="auto"
        :max-width="1000"
        :max-height="300"
        :pivot-y="0.5"
        :scrollable="true"
        :reset="true"
         >

        <img id="image" width="100%"
          src="../../../public/img/icons/dado1/12.jpg"
          alt
        />
      </modal>
      <modal name="img13" :adaptive="true"
        width="80%"
        height="auto"
        :max-width="1000"
        :max-height="300"
        :pivot-y="0.5"
        :scrollable="true"
        :reset="true"
         >

        <img id="image" width="100%"
          src="../../../public/img/icons/dado1/13.jpg"
          alt
        />
      </modal>
      <modal name="img14" :adaptive="true"
        width="80%"
        height="auto"
        :max-width="1000"
        :max-height="300"
        :pivot-y="0.5"
        :scrollable="true"
        :reset="true"
         >

        <img id="image" width="100%"
          src="../../../public/img/icons/dado1/14.jpg"
          alt
        />
      </modal>
      <modal name="img15" :adaptive="true"
        width="80%"
        height="auto"
        :max-width="1000"
        :max-height="300"
        :pivot-y="0.5"
        :scrollable="true"
        :reset="true"
         >

        <img id="image" width="100%"
          src="../../../public/img/icons/dado1/15.jpg"
          alt
        />
      </modal>
      <modal name="img16" :adaptive="true"
        width="80%"
        height="auto"
        :max-width="1000"
        :max-height="300"
        :pivot-y="0.5"
        :scrollable="true"
        :reset="true"
         >

        <img id="image" width="100%"
          src="../../../public/img/icons/dado1/16.jpg"
          alt
        />
      </modal>

       <modal name="img17" :adaptive="true"
        width="80%"
        height="auto"
        :max-width="1000"
        :max-height="300"
        :pivot-y="0.5"
        :scrollable="true"
        :reset="true"
         >

        <img id="image" width="100%"
          src="../../../public/img/icons/dado1/17.jpg"
          alt
        />
      </modal>

      <ul class="button-container">
        <li @click="$modal.show('img4')">
          <img src="../../../public/img/icons/dado1/4.jpg" class="img" id="img1" />
        </li>
        <li @click="$modal.show('img17')">
          <img src="../../../public/img/icons/dado1/17.jpg" class="img" id="img2" />
        </li>
        <li @click="$modal.show('img5')">
          <img src="../../../public/img/icons/dado1/5.jpg" alt class="img" id="img3" />
        </li>
        <li @click="$modal.show('img8')">
          <img src="../../../public/img/icons/dado1/8.jpg" class="img" id="img4" />
        </li>
        <li @click="$modal.show('img10')">
          <img src="../../../public/img/icons/dado1/10.jpg" class="img" id="img5" />
        </li>
        <li @click="$modal.show('img13')">
          <img src="../../../public/img/icons/dado1/13.jpg" alt class="img" id="img6" />
        </li>
        <li @click="$modal.show('img16')">
          <img src="../../../public/img/icons/dado1/16.jpg" class="img" id="img7" />
        </li>
      </ul>
      <ul class="button-container2">
        <li @click="$modal.show('img2')">
          <img src="../../../public/img/icons/dado1/2.jpg" class="img" id="img8" />
        </li>
        <li @click="$modal.show('img3')">
          <img src="../../../public/img/icons/dado1/3.jpg" alt class="img" id="img9" />
        </li>
        <li @click="$modal.show('img6')">
          <img src="../../../public/img/icons/dado1/6.jpg" class="img" id="img10" />
        </li>
        <li @click="$modal.show('img7')">
          <img src="../../../public/img/icons/dado1/7.jpg" class="img" id="img11" />
        </li>
        <li @click="$modal.show('img9')">
          <img src="../../../public/img/icons/dado1/9.jpg" alt class="img" id="img12" />
        </li>
        <li @click="$modal.show('img11')">
          <img src="../../../public/img/icons/dado1/11.jpg" class="img" id="img13" />
        </li>
        <li @click="$modal.show('img12')">
          <img src="../../../public/img/icons/dado1/12.jpg" alt class="img" id="img14" />
        </li>
        <li @click="$modal.show('img15')">
          <img src="../../../public/img/icons/dado1/15.jpg" class="img" id="img15" />
        </li>
        <li @click="$modal.show('img1')">
          <img src="../../../public/img/icons/dado1/1.jpg" class="img" id="img16" />
        </li>
        <li @click="$modal.show('img14')">
          <img src="../../../public/img/icons/dado1/14.jpg" alt class="img" id="img17" />
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  methods: {
    show () {
      this.$modal.show('img1')
      this.$modal.show('img2')
      this.$modal.show('img3')
      this.$modal.show('img4')
      this.$modal.show('img5')
      this.$modal.show('img6')
      this.$modal.show('img7')
      this.$modal.show('img8')
      this.$modal.show('img9')
      this.$modal.show('img10')
      this.$modal.show('img11')
      this.$modal.show('img12')
      this.$modal.show('img13')
      this.$modal.show('img14')
      this.$modal.show('img15')
      this.$modal.show('img16')
      this.$modal.show('img17')
    },
    hide () {
      this.$modal.hide('img1')
    }
  }
}
</script>

<style>
</style>
